import { CheckCircleFilled } from '@ant-design/icons';
import { CheckCircle } from 'lucide-react';

interface PricingCardProps {
	title: string;
	description: string;
	features: string[];
	bgClasses?: string;
	iconClass?: string;
	textClass?: string;
	darkBg?: string;
}

const PricingCard = ({
	title,
	description,
	features,
	bgClasses,
	iconClass,
	textClass,
	darkBg,
}: PricingCardProps) => {
	return (
		<div className="border rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
			<div className={'p-4 border-b flex relative ' + bgClasses}>
				<div
					className={
						'-mt-[0.125rem] w-8 h-8 rounded-full flex items-center justify-center mr-2 ' + iconClass
					}
				>
					{title === 'Lite' ? <CheckCircleFilled className="text-white" /> : null}
				</div>
				<h4 className={'text-lg font-medium ' + textClass}>{title}</h4>
				<p
					className={
						'absolute bottom-0 right-0 text-sm m-0 p-y-1 px-2 rounded-tl-lg text-white ' + darkBg
					}
				>
					{description}
				</p>
			</div>
			<div className="p-4">
				<div className="space-y-2">
					{features.map((feature) => (
						<div className="flex items-center" key={feature}>
							<CheckCircle className="text-gray-500 mr-2 w-3 h-3 min-w-3 min-h-3" />
							<span className="text-sm text-left">{feature}</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default PricingCard;
